import {Checkbox, makeStyles, Menu, MenuItem} from '@material-ui/core';
import clsx from 'clsx';
import { useHistory } from "react-router";
import {useDispatch} from 'react-redux';
import {
  initAnalysisData,
  updateClipedData
} from '../../../store/actions/creator/analysis';
import { getSessionParticipantsSuccess, initLiveAnalysisData } from '../../../store/actions/creator/creatorExperienceManager';
import UtilService from '../../../helper/service';
import moment from 'moment';
import roles from "../../../helper/roles";
import apiConfigs from '../../../config/config';
import {useRef, useState} from "react";

const useStyles = makeStyles(() => ({
  tr: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 14,
    borderBottom: '1px solid #F5F5F5',
    margin: '0 8px',
    background: '#E4E9EF',
    '& div': {
      textAlign: 'left'
    },
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  img: {
    width: 83,
    height: 52,
    borderRadius: 10,
    marginRight: 25
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  dotIcon: {
    width: 25,
    height: 25,
    cursor: 'pointer',
    verticalAlign:'middle'
  },
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

export function CreatorTableSubBody(props: any) {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const {
    selected, disableNavigation, onChangeSelected, clip, search, title,
    HEADER, experienceStart, sessionTrim, hoverIndex, deleteClip, onRenameClip } = props;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const startClip= clip.start - (sessionTrim ? sessionTrim : experienceStart);
  const endClip= clip.end - (sessionTrim ? sessionTrim : experienceStart);

  const onGoAnalysisClip = () => { 

    if (disableNavigation)
      return;

    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(clip.session_code));
    localStorage.setItem("session_id", String(clip.session_id));
    localStorage.setItem("session_name", String(title));
    let url = `/creator/experience-manager/analyze/${clip.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/analyze/${clip.session_code}`;
    }
    history.push(url, {session_id: clip.session_id});

    setTimeout(() => {

      dispatch(updateClipedData({
        title: clip.name,
        start_clip: clip.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(clip.start, false)/15 : clip.start,
        end_clip: clip.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(clip.end, true)/15 : clip.end,
        clip_id: clip.clip_id,
        score: {
          immersion: {
            immersion_index: clip.immersion,
            tier_indicator: clip.immersion_tier_indicator,
            color_indicator: clip.immersion_color_indicator,
            context_indicator: clip.immersion_context_indicator,
          },
          safety: {
            safety_index: clip.safety,
            tier_indicator: clip.safety_tier_indicator,
            color_indicator: clip.safety_color_indicator,
            context_indicator: clip.safety_context_indicator,
          }
        },
        length: clip.length,
        session_code: clip.session_code,
        session_id: clip.session_id,
        session_status: clip.session_status,
        session_title: clip.session_title,
        session_type: clip.session_type,
        img: clip.img,
        start: clip.start,
        end: clip.end
      }))
    }, 2000);

  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const handleMenuOpen = async () => {
    setOpenMenu(true);
  };

  const handleMenuClick = (index: number) => {
    if (index === 0) { // rename
      onRenameClip(clip, search);
      handleMenuClose();
    } else { // delete
      deleteClip(clip, search);
      handleMenuClose();
    }
  };

  return (
    <div className={classes.tr}>
      <div style={{ width: HEADER[0].width }}>
        {<Checkbox
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          color="primary"
          checked={selected && selected.length && (selected.findIndex((x: any) => x.session_id === clip.session_id)) !== -1}
          onChange={() => onChangeSelected(clip)}
          style={{ marginLeft: -8 }}
        />}
      </div>

      <div
        className={classes.left}
        onClick={onGoAnalysisClip}
        style={{ width: HEADER[1].width }}
      >
        <img
          src={`${apiConfigs.S3_IMG_URL}/small-${typeof clip.immersion === 'number' ? (clip.immersion % 70 + 1) : 64}.svg`}
          alt={'img'}
          className={classes.img}

        />
        <img src={'/assets/icons/dashboard/scissors.svg'} alt={'img'} style={{ marginRight: 8 }} />
        {clip.name}
      </div>

      <div
        className={classes.healthyText}
        style={{ width: HEADER[2].width, color: UtilService.refactorGraphColor(clip.immersion_color_indicator) }}
      >
        {clip.immersion}
      </div>

      <div
        className={classes.healthyText}
        style={{ width: HEADER[3].width, color: UtilService.refactorGraphColor(clip.safety_color_indicator) }}
      >
        { clip.safety === 1 ? '-' : clip.safety }
      </div>

      <div style={{ width: HEADER[4].width, textTransform: 'lowercase' }}>
        {clip.length}
      </div>

      <div style={{ width: HEADER[5].width }}>
        {clip.session_type === 'MODERATED' ? UtilService.secondsToHms(startClip>0?startClip:0):  typeof clip.start === 'number' ? moment(clip.start*1000).format('HH:mm:ss') : clip.start}
      </div>

      <div style={{ width: HEADER[6].width }}>
        {clip.session_type === 'MODERATED' ? UtilService.secondsToHms(endClip>0?endClip:0): typeof clip.end === 'number' ? moment(clip.end*1000).format('HH:mm:ss') : clip.end}
      </div>
      <div style={{ width: HEADER[7].width }}>
        {(clip.clip_id && hoverIndex === clip.clip_id) && (
          <img
            src={'/assets/icons/participant/dots-menu.svg'}
            alt='dot menu'
            className={classes.dotIcon}
            ref={anchorRef}
            onClick={handleMenuOpen}
          />
        )}
        <Menu
          anchorEl={anchorRef.current}
          onClose={handleMenuClose}
          open={openMenu}
          PaperProps={{
            style: {width: 'auto', marginTop: 50, borderRadius: 12}
          }}
        >
          {
            ['Rename', 'Delete'].map((option, index) => (
              <MenuItem
                className={classes.menuItem}
                key={option}
                onClick={() => handleMenuClick(index)}
              >
                <p className={classes.btn}>{option}</p>
              </MenuItem>
            ))
          }
        </Menu>

      </div>

    </div>
  )
}
